import { LOGGED_IN_COOKIE_NAME } from "@/lib/auth/constants";
import Cookies from "js-cookie";

const isUserLoggedIn = () => !!Cookies.get(LOGGED_IN_COOKIE_NAME);

export default isUserLoggedIn;
